<template>
  <div>
    <p v-html="linkedMessage"> </p>
    <p>
      {{ notificationData.text }}
    </p>
  </div>
</template>

<script>
import BaseComponent from '@/components/commentsNew/BaseComponent'

export default {
  name: 'shareNotification',
  extends: BaseComponent,
  props: {
    notificationData: {
      type: Object,
      required: true
    },
    itemTypeString: {
      type: String,
      required: true
    },
    itemType: {
      type: String,
      required: true
    }
  },
  computed: {
    linkedMessage () {
      const LINK = `<a href="${this.getUrl()}">${this.notificationData.name}</a>`
      return this.$t('{OBJECT} "{LINK}" was shared with you', { OBJECT: this.itemTypeString, LINK })
    }
  },
  methods: {
    getUrl () {
      const qsAppend = this.notificationData.yearId ? `&YearID=${this.notificationData.yearId}` : ''
      if (this.itemType === 'Unit') {
        return '/Atlas/Develop/UnitMap/View/Default?UnitID=' + this.notificationData.id + qsAppend
      } else if (this.itemType === 'UnitCalendar') {
        return '/Atlas/Develop/View/UnitCalendar?CurriculumMapID=' + this.notificationData.id + qsAppend
      } else if (this.itemType === 'CourseDescription') {
        return '/Atlas/Develop/View/CourseDescription?CurriculumMapID=' + this.notificationData.id + qsAppend
      } else if (this.itemType === 'CurriculumMap') {
        return '/Atlas/Browse/View/Map?CurriculumMapID=' + this.notificationData.id + qsAppend
      }
      return '/Atlas/View/SavedReport?SavedReportID=' + this.notificationData.id
    }
  }
}
</script>
